import { Vue, Component, Emit } from 'vue-property-decorator'
import { VoucherType } from '@/types'
import Axios from 'axios'
import moment from 'moment'

@Component
export default class FormSearchDocumentComponent extends Vue {
  voucherType: string = ''
  voucherSerie: string = ''
  voucherNumber: string = ''
  dateIssue: string = new Date().toISOString().substr(0, 10)
  dateIssueModal: boolean = false
  totalAmount: string = ''
  voucherTypes: VoucherType[] = []
  loading: boolean = false

  get dateIssueComputed () {
    return moment(this.dateIssue).format('DD/MM/YYYY')
  }

  mounted () {
    this.onLoadVoucherType()
  }

  onLoadVoucherType () {
    Axios.get('/documents/voucher-type').then(response => {
      this.voucherTypes = response.data
    })
  }

  onSearch () {
    const data = {
      voucherType: (this.voucherType as any).tipodoc,
      voucherSerie: this.voucherSerie,
      totalAmount: this.totalAmount,
      voucherNumber: this.voucherNumber,
      dateIssue: this.dateIssue,
      ruc: (document.head.querySelector('meta[name="ruc"]') as any).content
    }
    this.loading = true

    Axios.get('/documents/search', {
      params: data
    }).then(response => {
      this.loading = false
      this.$emit('onSearch', {
        ...data,
        token: response.data.accessToken
      })
    }
    ).catch(() => {
      this.loading = false
      this.$emit('onError')
    })
  }
}
